class RegisterTabs {
  constructor() {
    this.tabs = document.querySelectorAll('.register-tab');
    this.tabContents = document.querySelectorAll('.register-tab-content');
    this.urlParams = new URLSearchParams(window.location.search);
    this.tabParam = this.urlParams.get('tab');

    this.init();
  }

  init() {
    // Set initial active tab based on URL parameter or default to first tab
    if (this.tabParam && document.querySelector(`.register-tab[data-tab="${this.tabParam}"]`)) {
      this.activateTab(this.tabParam);
    } else if (this.tabs.length > 0) {
      this.tabs[0].setAttribute('data-active', '');
      this.tabContents[0].setAttribute('data-active', '');
    }

    // Add click event listeners to tabs
    this.addEventListeners();
  }

  activateTab(tabId) {
    // Remove active state from all tabs and contents
    this.tabs.forEach((tab) => tab.removeAttribute('data-active'));
    this.tabContents.forEach((content) => content.removeAttribute('data-active'));

    // Add active state to selected tab and content
    const selectedTab = document.querySelector(`.register-tab[data-tab="${tabId}"]`);
    const selectedContent = document.getElementById(selectedTab.dataset.target);

    if (selectedTab && selectedContent) {
      selectedTab.setAttribute('data-active', '');
      selectedContent.setAttribute('data-active', '');
    }
  }

  addEventListeners() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const tabId = tab.dataset.tab;
        this.activateTab(tabId);

        // Update URL without page reload
        const url = new URL(window.location);
        url.searchParams.set('tab', tabId);
        window.history.pushState({}, '', url);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  new RegisterTabs();
});
